module.exports = __webpack_public_path__ + "img/tv_cultura1.5431280e.jpg";